module.exports = __webpack_public_path__ + "static/media/Capa-WB43Free2.44e9562b.PNG";